import getConfig from 'next/config';

/**
 * Creates a React state reducer with action and state logger.
 * @param reducer
 * @returns {function(*=, *=): *}
 */
export function reducerWithLogger(reducer) {
  if (process.env.NODE_ENV === 'production') return reducer;

  return function(state, action) {
    console.log(
      '%cPrevious State:',
      'color: #9E9E9E; font-weight: 700;',
      state
    );
    console.log('%cAction:', 'color: #00A7F7; font-weight: 700;', action);
    console.log(
      '%cNext State:',
      'color: #47B04B; font-weight: 700;',
      reducer(state, action)
    );
    return reducer(state, action);
  };
}

const botUserAgents = [
  'googlebot',
  'mediapartners',
  'yahooysmcm',
  'bingbot',
  'bytespider',
  'baiduspider',
  'msnbot',
  'slurp',
  'teoma',
  'spider',
  'heritrix',
  'attentio',
  'twiceler',
  'irlbot',
  'fast crawler',
  'fastmobilecrawl',
  'jumpbot',
  'yahooseeker',
  'motionbot',
  'mediobot',
  'chtml generic',
  'pingdom',
  'yandexbot',
  'converacrawler',
  'ezooms.bot',
  'discoveryengine',
  'blekkobot',
  'bddtestbrowser',
  'symfony browserkit',
];

// Cache result
let _realUser = null;

/**
 * @returns {boolean}
 */
export function isRealBrowser() {
  if (_realUser === null) {
    _realUser = true;
    if (typeof window === 'undefined' || !window.navigator.userAgent) {
      _realUser = false;
    } else {
      const ua = window.navigator.userAgent.toLowerCase();
      botUserAgents.forEach(substr => {
        if (ua.includes(substr)) {
          _realUser = false;
        }
      });
    }
  }

  return _realUser;
}

const {
  publicRuntimeConfig: { BRAINZY_TAB_DEBUG },
} = getConfig();

/**
 * Opens kidframe on a new window without menubar
 * If running on dev with BRAINZY_TAB_DEBUG env var, will open in new tab
 * @param href - by default opens on choose player
 */
export function openKidFrame(href = '/games/play/') {
  //If on dev env with proper flag, launch in new tab
  if (BRAINZY_TAB_DEBUG === 'true') {
    window.open(href);
    //Otherwise launch in new window
  } else {
    let h = screen.availHeight ? screen.availHeight : screen.height,
      w = screen.availWidth ? screen.availWidth : screen.width;
    h = h > 1250 ? 1250 : h;
    w = w > 1920 ? 1920 : w;
    h = h - 14;
    w = w - 14;
    let gameWindow = window.open(
      href,
      '',
      'scrollbars=no,menubar=no,location=no,status=no,toolbar=no,outerHeight=' +
        h +
        ',height=' +
        h +
        ',outerWidth=' +
        w +
        ',width=' +
        w +
        ',fullscreen=yes,left=0,top=0,resizable=yes'
    );
    gameWindow.focus();
  }
}
